<ng-container *transloco="let t; prefix: this.scope">
  <div class="flex py-4 bg-page">
    <div *ngIf="loggedInUser" class="flex flex-1 items-center pl-4">
      <div class="flex">
        <bl-frontend-button
          variant="tonal"
          [text]="t('createNewNote')"
          class="mr-6"
          [leadingIcon]="{ name: 'calendar-plus' }"
          (onclick)="onNewNoteClicked()">
        </bl-frontend-button>
      </div>

      <bl-frontend-button
        *ngIf="(hasActiveConnection$ | async) === false"
        variant="tonal"
        [text]="t('getStartedWithAml')"
        class="self-center"
        (onclick)="onDueComplianceClick()">
      </bl-frontend-button>
    </div>

    <div *ngIf="loggedInUser" class="flex items-center text-white space-x-3 mr-6">
      <ng-container *appHideIfCountries="'NL'">
        <div *appPartnerProgramAccess>
          <div class="flex relative">
            <bl-frontend-button
              variant="tonal"
              [text]="t('partnerProgram')"
              [leadingIcon]="{ name: 'heart' }"
              (onclick)="navigateToPartnerProgram()">
            </bl-frontend-button>
            <div
              *ngIf="(missingPartnerPackages$ | async) > 0"
              class="flex absolute pin-r pin-t -top-2 right-0 rounded-full text-white text-xs bg-blg-blue-600 h-5 w-5 justify-center items-center">
              {{ missingPartnerPackages$ | async }}
            </div>
          </div>
        </div>
      </ng-container>

      <bl-frontend-button
        variant="tonal"
        [text]="t('firmSettings')"
        [leadingIcon]="{ name: 'gear' }"
        (onclick)="onFirmSettingsClicked()">
      </bl-frontend-button>

      <app-help-menu></app-help-menu>

      <bl-frontend-floating-button-menu [menuItems]="profileMenuItems" iconName="user" [maxMenuHeight]="400">
        <div snippet="menuHeader" class="p-4 pb-3 mb-2 border-b border-ghost">
          <p class="font-medium text-label">{{ loggedInUser.name }}</p>
          <p class="text-sm text-description">{{ loggedInUser.email }}</p>
        </div>
      </bl-frontend-floating-button-menu>
    </div>
  </div>
</ng-container>
